"use strict";

exports.__esModule = true;
exports["default"] = reducer;
var initialState = {};

function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	return state;
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/datagridDefaultState.js
 ** module id = 1032
 ** module chunks = 2
 **/